<script setup></script>

<template>
  <div class="app">
    <RouterView />
  </div>
</template>

<style scoped lang="less">
.app {
  height: 100%;
}
</style>

<style lang="less">
#app {
  height: 100%;
}
</style>
